import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-box',
  standalone: true,
  imports: [],
  templateUrl: './loading-box.component.html',
  styleUrl: './loading-box.component.css',
})
export class LoadingBoxComponent {
  @Input() rows: number = 1;

  get rowsArray(): number[] {
    return Array.from({ length: this.rows }, (_, i) => i);
  }
}
